module.exports = __webpack_public_path__ + "static/img/tryout_bc_01_zh.93025cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tryout/tryout_bc_01_zh.png
// module id = 6W3k
// module chunks = 34